import { render } from "./LoadPatientsDialog.vue?vue&type=template&id=de95e89e"
import script from "./LoadPatientsDialog.vue?vue&type=script&lang=js"
export * from "./LoadPatientsDialog.vue?vue&type=script&lang=js"

import "./LoadPatientsDialog.vue?vue&type=style&index=0&id=de95e89e&lang=css"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__